import { AES, enc } from "crypto-js";

// Kunci rahasia yang digunakan untuk enkripsi
const secretKey = "UIPOEHJSLDYRGDJS";

// Fungsi untuk mendekripsi dan mengambil data array dari local storage
export const decryptArrayLocalStorage = (key) => {
  try {
    const encryptedValue = localStorage.getItem(key);
    if (encryptedValue) {
      const decryptedValue = AES.decrypt(encryptedValue, secretKey).toString(
        enc.Utf8
      );
      return JSON.parse(decryptedValue);
    }
    return null;
  } catch (error) {
    console.error("Error decrypting data:", error);
    return null; // Mengembalikan nilai default atau null jika terjadi error
  }
};
